module.exports = __webpack_public_path__ + "img/diamond.38430280.svg";